import { Link } from 'react-router-dom'
import { blogUrlParam } from "../utilities"

//*********************************************************************/

export const BlogCard = ({ blog }) =>  {

  const pubDate = new Date(blog.fields.publishedDate).toDateString()

  let imageUrl = blog.fields.bannerImage?.fields?.file?.url || ''
  if (imageUrl.startsWith('//')) {
    imageUrl = 'https:' + imageUrl
  }

  //*********************************************************************/

  return (

    <Link to={'/blog/'+ blogUrlParam(blog.fields.title)} >
      <div className="BlogCard">

          <img src={imageUrl} alt="thumb"/>
          <div style={{ margin: "8px 20px 0 20px" }}>
            <div  className="BlogTitle">{blog.fields.title}</div>
            <div className="TextSmall" style={{ margin: "10px 0" }}>{blog.fields.subTitle}</div>
            <div style={{ margin: "20px 0", color: "gray", fontWeight: 500 }}>{}</div>
          </div>
      </div>
    </Link>
  )

  //*********************************************************************/
}